import React from "react";
import { emptyCellCharacter } from "../../types.js";
import { RouterLinkText } from "../../../link/LinkText.js";
import "../../../link/LinkButton.js";
const renderTextLink = (params) => {
  const { path, id, title } = params.value;
  return path?.length && (id || title) ? /* @__PURE__ */ React.createElement(RouterLinkText, { title: title ?? id, path, id }) : /* @__PURE__ */ React.createElement(React.Fragment, null, emptyCellCharacter);
};
export {
  renderTextLink
};
//# sourceMappingURL=TextLinkCell.js.map
